import React from "react";
import { withTranslation } from "react-i18next";

const NeedHelpHeader = ({ t }) => (
  <div className="header">
    <h4>{t("howCanWeHelp")}</h4>
    <p>{t("findRightAnswer")}</p>
  </div>
);
export default withTranslation("needHelp")(NeedHelpHeader);
